import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function InvalidToken() {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h5" align="center" sx={{ marginBottom: 10 }}>
        {t('invalid_token')}
      </Typography>
    </>
  );
}
